import { render } from "./DeleteContractModal.vue?vue&type=template&id=53cf3fe4"
import script from "./DeleteContractModal.vue?vue&type=script&lang=js"
export * from "./DeleteContractModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__